import { AdvanceSearchProperties } from './advance-search-properties.model';

export class AdvanceSearchRequest {
    searchText: string;
    includeProperties: AdvanceSearchProperties[];
    combineProperties: any;

    constructor() {
        this.searchText = '';
        this.includeProperties = [];
        this.combineProperties = {};
    }
}
